import styled from 'styled-components'

export const AnswerGroupTitleUi = styled.div`
  display: flex;
  justify-content: space-around;
`
